var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{staticClass:"input-search",attrs:{"placeholder":"Search...","suffix-icon":"ion ion-search-outline","clearable":""},on:{"change":_vm.handlerSearch},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})
}
var staticRenderFns = []

export { render, staticRenderFns }